/**
 * Company: SPHMedia
 * Description: [Gets Long Form videos data]
 */

import fetchBHApi from "@helper/fetchBHApi";
import type { LatestVideoResponse } from "@typings/Brightcove.d";
import { useEffect, useState } from "react";

type useLongFormVideoData = {
  playing: LatestVideoResponse;
};

/**
 * Custom React Hook: useLongFormVideo
 * Description: [Gets Long Form videos from bc playlist]
 * @returns data - The data returned by the hook
 */
export default function useLongFormVideo(size = 1): useLongFormVideoData {
  const [playing, setPlaying] = useState<LatestVideoResponse>({
    id: "",
  } as LatestVideoResponse);

  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = `latest-videos?size=${size}`;
      try {
        const videos = await fetchBHApi<LatestVideoResponse[]>(apiUrl, "GET");
        const limitedContent = videos[0];
        if (limitedContent.id !== "") {
          setPlaying(limitedContent);
        }
      } catch (error) {
        console.error(
          "[InfiniteScroll] Error fetching long-form video:",
          error,
        );
      }
    };
    void fetchData();
  }, [size]);

  return { playing };
}
